import { render, staticRenderFns } from "./GetUserSettings.vue?vue&type=template&id=53b153d7&"
import script from "./GetUserSettings.vue?vue&type=script&lang=js&"
export * from "./GetUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports